module.exports = __webpack_public_path__ + "static/Neutraface-Slab-Text-Demi-91bf7ec1ed3ee03e065588693d91d650.otf";